<template>
  <div></div>
</template>
<script>
export default {
  name: 'LoadSimulationGraphicReport',
}; // TODO: 35519
</script>
<style scoped>
</style>
